import React from "react";
import { getAuth, sendPasswordResetEmail } from "firebase/auth"; // Import the correct functions
import { useNavigate } from "react-router-dom";
import "./ForgotPassword.css";

function ForgotPassword() {
    const auth = getAuth();
    const history = useNavigate();
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      const emailVal = e.target.email.value;
  
      sendPasswordResetEmail(auth, emailVal)
        .then(() => {
          alert("Check your email for password reset instructions.");
          history("/"); // Redirect to the homepage after password reset
        })
        .catch((err) => {
          alert(err.message);
        });
    };

  return (
    <div className="forgot-password-container">
      <h1 className="page-title">Ehipassiko Buddhist Centre</h1>
      <p className="page-description">
      Enlightened Path Fellowship Inc. is committed to fostering Buddhist teachings, meditation, 
      and cultural values within the Sri Lankan and wider Australian community. Our temple, Ehipassiko Buddhist Center Bundoora, 
      serves as a sanctuary for spiritual growth, cultural enrichment, and social welfare, guided by the compassionate
      wisdom of Lord Buddha.
      </p>
      <div className="">
        <h2 className="form-title">Forgot Password</h2>
        <p className="forgot-password-paragraph">
          Please enter your registered email address below to receive instructions for resetting your password.
        </p>
        <form onSubmit={handleSubmit}>
          <input
            className="form-control"
            type="email"
            name="email"
            placeholder="Enter your email"
            required
          />
          <button className="btn-reset" type="submit">
            Reset Password
          </button>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
